import { CompoundButton, Divider, mergeClasses, tokens } from "@fluentui/react-components";
import { SSOIcon, SyntheiaLogo } from "../../../components/icons";
import { useWelcomeSectionStyles } from "../styles/WelcomeSection.styles";

type WelcomeSectionProps = {
  isAzureEnabled: boolean;
  onLoginWithAzureClick?: () => void;
};

export const WelcomeSection = ({ isAzureEnabled, onLoginWithAzureClick }: WelcomeSectionProps) => {
  const styles = useWelcomeSectionStyles();

  return (
    <>
      <div
        className={mergeClasses(styles.flexColumnStyle, styles.fullWidth, styles.logoContainer, styles.flexCentered)}
      >
        <SyntheiaLogo />
      </div>
      <div className={mergeClasses(styles.flexColumnStyle, styles.headTitleContainer)}>
        <div>
          <span className={mergeClasses(styles.headTitleSmall, styles.textUpperCase)}>Welcome back</span>
        </div>
        <div>
          <span className={styles.headTitleLarge}>Sign into your account.</span>
        </div>
      </div>
      {isAzureEnabled && (
        <div className={styles.fullWidth}>
          <CompoundButton
            icon={<SSOIcon color={tokens.colorBrandBackground} />}
            shape="rounded"
            appearance="outline"
            size="large"
            onClick={onLoginWithAzureClick}
            className={mergeClasses(styles.fullWidth, styles.ssoBtn)}
          >
            Log In with SSO
          </CompoundButton>
        </div>
      )}
      <div className={styles.dividerContainer}>
        <Divider className={styles.optionDivider}>{isAzureEnabled ? "Or" : ""} Use Email</Divider>
      </div>
    </>
  );
};
